var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('delivery-options',{ref:"deliveryOptions",attrs:{"loading":_vm.deliveryLoading,"delivery-price":_vm.deliveryPrice,"radios":_vm.selectedRadio,"disableRadios":_vm.foreignCountryDelivery},on:{"delivery-option-changed":_vm.deliveryChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }